import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cumulateListsLengthsPipe'
})
export class CumulateListsLengthsPipe implements PipeTransform {
  transform(...sources: any): number {
    return sources
    .filter((source: any) => Array.isArray(source))
    .reduce((acc: number, source: any[]) => acc + source.length, 0)
  }
}